import { useQuery } from "@tanstack/react-query";
import { FaAndroid, FaApple, FaWindows } from "react-icons/fa";
import { useRef, useState } from "react";

import { Api } from "@src/services/api";

import { isAndroid } from "@src/utils/isAndroid";
import { isIos } from "@src/utils/isIos";
import { isMobile } from "@src/utils/isMobile";
import { isNativeApp } from "@src/utils/isNativeApp";
import { browserName } from "@src/utils/browser";

import "./style.less";

export function Download() {
  const { data } = useQuery({
    queryKey: ["electronVersion"],
    queryFn: Api.getElectronVersion,
  });

  const [easterEgg, setEasterEgg] = useState(false);
  const clickCount = useRef(0);

  const handleTitleClick = () => {
    clickCount.current += 1;
    if (clickCount.current >= 3) {
      setEasterEgg(true);
    }
  };

  if (isNativeApp) return <></>;

  const showWindows = easterEgg || (browserName !== "Electron" && !isMobile && !!data);
  const showAndroid = easterEgg || (isMobile && !isIos);
  const showIos = easterEgg || (isMobile && !isAndroid);

  if (!showWindows && !showAndroid && !showIos) {
    return <></>;
  }

  return (
    <div className="Download-component">
      <span className="Download-title" onClick={handleTitleClick}>Baixe o FabriccaPro</span>
      <div className="Download-icons">
        {showWindows && !!data && (
          <a
            href={data.url}
            target="_blank"
            rel="noopener noreferrer"
            title="Baixar FabriccaPro para Windows"
          >
            <FaWindows />
          </a>
        )}
        {showAndroid && (
          <a
            href="https://play.google.com/store/apps/details?id=pro.fabricca.app"
            target="_blank"
            rel="noopener noreferrer"
            title="Baixar FabriccaPro para Android"
          >
            <FaAndroid />
          </a>
        )}
        {showIos && (
          <a
            href="https://apps.apple.com/us/app/fabriccapro/id6758517975"
            target="_blank"
            rel="noopener noreferrer"
            title="Baixar FabriccaPro para iOS"
          >
            <FaApple />
          </a>
        )}
      </div>
    </div>
  );
}
